<template>
	<div class="animated fadeIn">
		<b-row>
			<b-col lg="12" xl="12">
				<b-card>
					<div slot="header">
					<strong>{{this.$route.params.id == 'add' ? 'Pattern add' : 'Pattern Edit'}}</strong>
					</div>
          <b-form-group>
            <label for="category">카테고리</label>
            <b-form-select v-model="model.category" :options="codes.code_category"></b-form-select>
          </b-form-group>
          <b-form-group>
            <label for="ext">종류</label>
            <b-form-select v-model="model.ext" :options="codes.code_ext"></b-form-select>
          </b-form-group>
          <b-form-group>
            <label for="type">타입</label>
            <b-form-select v-model="model.type" :options="codes.code_type"></b-form-select>
          </b-form-group>
          <b-form-group>
            <label for="code">코드</label>
            <b-form-input md="5" type="text" id="code" v-model="model.code"></b-form-input>
          </b-form-group>
          <b-form-group>
            <label for="description">설명</label>
            <b-form-textarea :rows="3" v-model="model.description" id="descript"></b-form-textarea>
          </b-form-group>
          <b-form-group label="사용여부" label-for="ph_active" v-b-tooltip.hover>
            <c-switch v-model="model.is_alive"  :disabled="lock" color="success" label variant="pill"/><br>
          </b-form-group>
          <hr />
          <b-button size="sm" variant="primary" @click="test"> 테스트 </b-button>
          <b-button class="btn-add" size="sm" variant="success" @click="save"> 저장 </b-button>
          <b-button size="sm" variant="default" @click="cancel" class="btn-cancel"> 닫기 </b-button>
          <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> 목록으로 </b-button>
				</b-card>
			</b-col>
		</b-row>
		<router-view></router-view>
	</div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
